export default {
  switchLink: 'Switch to Russian',
}
